export default __webpack_public_path__ + "static/media/secondaryLogo.ff14ece3.svg";